import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Strip HTML tags and collapse whitespace so a rich-text field can be safely
 * shown as a plain-text excerpt (e.g. inside a card with line-clamp-3).
 * Also decodes the most common HTML entities so nothing looks encoded.
 */
export function htmlToExcerpt(html, maxLen = 240) {
  if (!html) return "";
  let text = String(html)
    // drop script/style blocks first
    .replace(/<(script|style)[^>]*>[\s\S]*?<\/\1>/gi, "")
    // paragraph & line-break tags → spaces so words don't stick together
    .replace(/<\/(p|h[1-6]|li|div|blockquote)>/gi, " ")
    .replace(/<br\s*\/?>/gi, " ")
    // remove all other tags
    .replace(/<[^>]+>/g, "")
    // decode a small set of common entities
    .replace(/&nbsp;/g, " ")
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&#39;|&apos;/g, "'")
    .replace(/&hellip;/g, "…")
    .replace(/&mdash;/g, "—")
    .replace(/&ndash;/g, "–")
    .replace(/\s+/g, " ")
    .trim();
  if (text.length > maxLen) text = text.slice(0, maxLen).trimEnd() + "…";
  return text;
}
